import React from 'react';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/custom/DisplayLongDescriptionAndVariantMFRName';
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Constants from 'src/helper/Constants';
import { useProductStore } from 'src/hooks/product';

const PriceMisMatchBackOrder = (props) => {
    const { SetStatus } = props;
    const { single_product, PRODUCT_PRICE, PRODUCT_INVENTORY } = props.data;
    const [{ }, { }, { ADD_TO_CART }] = useCartStore();
    const [{ }, { get_inventory_lead_time, get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [{ }, { get_end_customer_by_cpn }, { }] = useProductStore();

    const onHide = () => {
        SetStatus(false)
    };

    const updateQty = async () => {
        const v = single_product;
        let param = {
            "partNumber": v.ERPPartNumber,
            "assetURL": v.assetURL,
            "ItemNumber": v.ItemNumber,
            "ManufacturerPartNumber": v.ManufacturerPartNumber,
            "ERPMFRPartNumber": v.ERPMFRPartNumber,
            "quantity": PRODUCT_PRICE.quantity,
            "totalQuantity": v.totalQuantity, //added
            "backOrderedQuantity": v.backOrderedQuantity,
            "subtotal": v.subtotal,
            "manufacturerCode": v.ManufacturerCode,
            "manufacturerName": v.ManufacturerName,
            "erpManufacturerCode": v.ERPManufacturerCode,
            "erpManufacturerName": v.ERPManufacturerName,
            "cpn": v.cpn,
            "default_plant": v.default_plant,
            "mdmMaterialId": v.MDMMaterialID,
            "endCustAccNum": get_end_customer_by_cpn(v.CustomerPartNumbers, v.cpn),
            'isSoftwareDownloadable': v?.SoftwareDownloadFlag,
            'seoerpmfrPartNumber': v?.SEOERPMFRPartNumber,
            'seoManufacturerName': v?.SEOManufacturerName
        }

        await ADD_TO_CART(param, props.data.isManuallyAddCart)

        if (props.data.productAddedToCartCallback) {
            props.data.productAddedToCartCallback();
        }
        if (props.data?.isFrom) {
            System.setEvars(v?.ERPMFRPartNumber, "Add to Cart clicked from " + props.data?.isFrom)
        }

        onHide(false);
    }

    return (
        <div className="avnet-modal modal-680">
            <div className="avnet-modal-inner">
                {/* Modal Header */}
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => { onHide() }}>×
                </button>
                <div className="modal-header justify-content-center mt-0">
                    <h3 className="pcn-modal-heading">Price Mismatch and Inventory Alert</h3>
                </div>
                <div className="m-4 mt-0 mb-0">
                    <div className="justify-content-start">
                        There is a mismatch between selected Quantity and the available price tier. <br />
                        We currently do not have sufficient inventory for the following item(s).<br />
                        Please contact your local sales officer for a lower quantity pricing.<br /><br />

                        Confirm the adjusted quantity and backorder by clicking the <b>Yes</b> button below.
                    </div>
                </div>
                <div className="modal-body">
                    <div className="inventory-table price-mismatch-table">
                        <table className="table table-outline rounded-0">
                            <thead>
                                <tr className="bg-light">
                                    <th colSpan={4} className='text-center'>Price Mismatch</th>
                                </tr>
                                <tr>
                                    <th className="border-0 text-none font-12">Product(s)</th>
                                    <th className="border-0 text-none font-12">Requested Qty</th>
                                    <th className="border-0 text-none font-12">Adjusted Qty</th>
                                    <th className="border-0 text-none font-12">Unit Price</th>
                                </tr>
                            </thead>
                            <tbody className="border-top-0">

                                    <tr>
                                        <td className="align-middle">
                                            <div className="inventory-product-info">
                                                <div className="inventory-product-name">
                                                    <NavigateToProductDetail data={{ SEOManufacturerName: single_product?.SEOManufacturerName, SEOERPMFRPartNumber: single_product?.SEOERPMFRPartNumber, ItemNumber: single_product?.ItemNumber, ERPPartNumber: single_product?.ERPPartNumber }}>
                                                        <b className='text-black'>{single_product.ERPMFRPartNumber}</b>
                                                    </NavigateToProductDetail>
                                                </div>
                                                <div className="inventory-product-by">
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={{ ManufacturerName: single_product?.ManufacturerName, ShortDescription: single_product?.ShortDescription }} />
                                                    <span className='astric mb-1'>See inventory Alert for this item</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="align-top">
                                            <span>{single_product.quantity}</span>
                                        </td>
                                        <td className="align-top">
                                            <span>{PRODUCT_PRICE.quantity}</span>
                                        </td>
                                        <td className="align-top">
                                            <span>{System.getFormatNumber({amount: Number(PRODUCT_PRICE.marketPrice)})}</span>
                                        </td>
                                    </tr>
                                    <tr className='bg-light'><th colSpan={4} className='text-center'>Inventory Alert</th></tr>
                                    <tr>
                                        <td colSpan={2}></td>
                                        <th>Adjusted Qty</th>
                                        <th>Backorder Qty</th>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <div className="inventory-product-stock"><b>In
                                                Stock: {PRODUCT_INVENTORY.quantity}</b>
                                            </div>
                                            <div className="inventory-product-lead">Lead Time From
                                                Supplier: {get_inventory_lead_time(single_product?.FactoryLeadTime, single_product?.constrainPartFlag)}
                                            </div>
                                        </td>
                                        <td>
                                            <span>{PRODUCT_PRICE.quantity}</span>
                                        </td>
                                        <td>
                                            <span>{PRODUCT_PRICE.quantity}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className='text-end'><p>Item Subtotal: (EUR) <strong>€577,60</strong> </p> </div>

                    </div>
                </div>
                {/* Modal footer */}
                <div className="modal-footer justify-content-center">
                    <div className="modal-footer-actions">
                        <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                            data-bs-toggle="modal" data-bs-target="#InventoryModal"
                            onClick={() => { onHide(false) }}>
                            No
                        </button>
                        <button type="button" className="bs5 btn btn-primary btn-sm w145"
                            onClick={async () => { await updateQty() }}
                            data-bs-toggle="modal" data-bs-target="#InventoryModal">
                            Yes
                        </button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default PriceMisMatchBackOrder;